export const SET_SESSION_KEY = (state, key) => {
  state.sessionKey = key;
  localStorage.setItem("session-key", JSON.stringify(key));
};

export const SET_ROOM = (state, room) => {
  state.room = room;
  localStorage.setItem("room", JSON.stringify(room));
};

export const SET_FORM_INFO = (state, form) => {
  state.room = form;
  localStorage.setItem("form", JSON.stringify(form));
};

export const SET_SINGLE_DAY_PRICE = (state, payload) => {
  state.singleDayPrice = payload;
};
